import React, { useEffect } from "react";
import { Formula } from "../../api";
import { Modal, Form, InputNumber } from "antd";

export default function Function7FormulaModal({
  A,
  B,
  visible,
  data,
  setA,
  setB,
  setVisible,
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        VoltageA: A[0],
        VoltageB: B[0],
        RpressureA: A[1],
        RpressureB: B[1],
        SpressureA: A[2],
        SpressureB: B[2],
        TpressureA: A[3],
        TpressureB: B[3],
      });
    }
  }, [visible, A, B, form]);
  const onSubmit = async () => {
    const {
      VoltageA,
      VoltageB,
      RpressureA,
      RpressureB,
      SpressureA,
      SpressureB,
      TpressureA,
      TpressureB,
    } = form.getFieldsValue();
    await Formula.Function7UpdateFormula(
      data.id,
      [VoltageA, RpressureA, SpressureA, TpressureA],
      [VoltageB, RpressureB, SpressureB, TpressureB]
    );
    setA([VoltageA, RpressureA, SpressureA, TpressureA]);
    setB([VoltageB, RpressureB, SpressureB, TpressureB]);
    setVisible(false);
  };
  return (
    <Modal
      title="數位油壓線性調整"
      open={visible}
      onCancel={() => setVisible(false)}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={onSubmit} layout="inline">
        <Form.Item name="VoltageA" label="機具電壓 A">
          <InputNumber />
        </Form.Item>
        <Form.Item name="VoltageB" label="機具電壓 B">
          <InputNumber />
        </Form.Item>
        <Form.Item name="RpressureA" label="R相油壓 A">
          <InputNumber />
        </Form.Item>
        <Form.Item name="RpressureB" label="R相油壓 B">
          <InputNumber />
        </Form.Item>
        <Form.Item name="SpressureA" label="S相油壓 A">
          <InputNumber />
        </Form.Item>
        <Form.Item name="SpressureB" label="S相油壓 B">
          <InputNumber />
        </Form.Item>
        <Form.Item name="TpressureA" label="T相油壓 A">
          <InputNumber />
        </Form.Item>
        <Form.Item name="TpressureB" label="T相油壓 B">
          <InputNumber />
        </Form.Item>
      </Form>
    </Modal>
  );
}
